import React, { useState, useEffect } from 'react';
import "../styles/third.css"; // Make sure to use the updated CSS file

const CourseCarousel = () => {
  // Enhanced course data with detailed descriptions
  const courses = [
    {
      id: 1,
      title: "Web 3.0 & Full Stack AI Developer",
      description: "Master modern frontend and backend technologies to build intelligent AI-powered applications. Learn to develop decentralized apps, implement smart contracts, and integrate AI agents into cutting-edge web solutions.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/web3_fullstack.webp",
      color: "#F5E6E8",
    },
    {
      id: 2,
      title: "Quantum Computing",
      description: "Explore the revolutionary field of quantum computing and its applications in cryptography, drug discovery, and financial modeling. Learn quantum algorithms, quantum machine learning, and how to program quantum computers.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/DALL%C2%B7E+2025-01-06+22.50.34+-+A+futuristic+and+sleek+promotional+poster+for+a+Quantum+Computing+course.+The+design+incorporates+cutting-edge+elements+such+as+quantum+circuits%2C+enta.webp",
      color: "#F9F6A9",
    },
    {
      id: 3,
      title: "Data Science & Big Data Engineer",
      description: "Become proficient in data analysis, statistical modeling, and machine learning techniques. Learn to process and analyze massive datasets using big data technologies like Hadoop, Spark, and advanced visualization tools.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/data_science.webp",
      color: "#FEF9E7",
    },
    {
      id: 4,
      title: "UI/UX Designing for AI & Quantum Applications",
      description: "Create intuitive and engaging user experiences for next-generation AI and quantum computing applications. Master design thinking, wireframing, prototyping, and user research specifically tailored for advanced technology interfaces.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/Uiux_academy.png",
      color: "#A3E4E9",
    },
    {
      id: 5,
      title: "Decentralized Mobile Apps Development",
      description: "Learn to build secure, decentralized mobile applications using blockchain technology. Master cross-platform development frameworks while implementing distributed ledger solutions for iOS and Android platforms.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/mobile_dapps.webp",
      color: "#FCF3CF",
    },
    {
      id: 6,
      title: "Cloud Computing & DevOps",
      description: "Gain expertise in deploying, scaling, and managing applications across major cloud platforms. Master containerization, orchestration, CI/CD pipelines, and infrastructure as code to streamline application deployment and management.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/cloud_computing.webp",
      color: "#FCDE67",
    },
    {
      id: 7,
      title: "Blockchain & D-Apps Developer",
      description: "Become proficient in blockchain technologies and smart contract development. Learn to build decentralized applications on platforms like Ethereum, Solana, and Polkadot while mastering Web3 integration and token economics.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/block.png",
      color: "#E8F8F5",
    },
    {
      id: 8,
      title: "Renewable Energy Engineer",
      description: "Develop expertise in sustainable energy technologies including solar, wind, and geothermal systems. Learn to design, implement, and optimize renewable energy solutions with a focus on efficiency and environmental impact.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/DALL%C2%B7E+2025-01-05+10.43.28+-+A+high-quality+and+professional+promotional+image+for+online+courses+in+Geology+and+Geophysics+by+Olewin+Academy%2C+highlighting+'Learn+from+IIT+Alumni'.webp",
      color: "#D5F5E3",
    },
    {
      id: 9,
      title: "AI Agents & LLM Engineers",
      description: "Master the development of advanced AI agents and large language models. Learn to fine-tune, deploy, and integrate state-of-the-art AI systems for various applications including conversational agents, content generation, and automated reasoning.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/ai_llm.webp",
      color: "#FADBD8",
    },
    {
      id: 10,
      title: "Robotics Engineers",
      description: "Learn to design, build, and program autonomous robotic systems. Master sensor integration, control systems, computer vision, and AI implementation for robotics applications across industrial, healthcare, and consumer sectors.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/robotic.webp",
      color: "#D6EAF8",
    },
    {
      id: 11,
      title: "IoT with Cloud, AI & D-Apps",
      description: "Develop advanced IoT solutions that integrate cloud services, AI, and decentralized applications. Learn to work with Raspberry Pi, Arduino, and AWS IoT to create smart, connected devices with secure blockchain integration.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/iot.png",
      color: "#F4ECF7",
    },
    {
      id: 12,
      title: "Business Analytics & Project Management",
      description: "Develop strong analytical and leadership skills for managing complex technology projects. Learn data-driven decision making, agile methodologies, and business intelligence tools to drive successful project outcomes.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/business_analytics.webp",
      color: "#EAF2F8",
    },
    {
      id: 13,
      title: "Geotechnical Engineering",
      description: "Master the principles of soil mechanics, foundation design, and geological engineering. Learn advanced modeling techniques and sustainable approaches to infrastructure development with a focus on environmental impact.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/geotechnical.webp",
      color: "#FEF5E7",
    },
    {
      id: 14,
      title: "AI & ML Engineering",
      description: "Become an expert in developing AI and machine learning solutions for real-world problems. Master deep learning, natural language processing, computer vision, and reinforcement learning techniques using cutting-edge frameworks.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/ai_ml.webp",
      color: "#E5E8E8",
    },
    {
      id: 15,
      title: "Android & iOS Development",
      description: "Learn to build native mobile applications for both Android and iOS platforms. Master UI design, local data storage, API integration, and advanced features like AR/VR, location services, and push notifications.",
      image: "https://myacademyimages.s3.eu-north-1.amazonaws.com/mobile_dev.webp",
      color: "#FDEDEC",
    }
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  // Auto-rotate carousel every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(prevIndex => (prevIndex + 1) % courses.length);
    }, 4000);
    
    return () => clearInterval(interval);
  }, [courses.length]);

  // Handle dot navigation
  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  // Handle touch events for mobile swipe
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      // Swipe left, go next
      setActiveIndex(prevIndex => (prevIndex + 1) % courses.length);
    }

    if (touchStart - touchEnd < -50) {
      // Swipe right, go previous
      setActiveIndex(prevIndex => (prevIndex === 0 ? courses.length - 1 : prevIndex - 1));
    }
  };

  return (
    <div className="carousel-container2">
      <div className="carousel-header">
        <h2 className="carousel-title">On-Demand Program/Courses</h2>
        <p className="intro-text">
          We are India's first institute/academy providing future-tech-integrated courses for renewable sector programs in geosciences.
        </p>
      </div>
      
      <div 
        className="carousel-wrapper" 
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div className="carousel-cards">
          {courses.map((course, index) => {
            // Calculate the position class
            let positionClass = '';
            const diff = (index - activeIndex + courses.length) % courses.length;
            
            if (diff === 0) positionClass = 'active';
            else if (diff === 1) positionClass = 'next';
            else if (diff === courses.length - 1) positionClass = 'prev';
            else if (diff < courses.length / 2 && diff > 1) positionClass = 'far-next';
            else positionClass = 'far-prev';
            
            return (
              <div 
                key={course.id} 
                className={`carousel-card ${positionClass}`} 
                style={{ backgroundColor: course.color || '#ffffff' }}
              >
                <div className="card-image">
                  <img src={course.image} alt={course.title} />
                </div>
                <div className="card-content">
                  <h3 className="card-title">{course.title}</h3>
                  <div className="card-description-wrapper">
                    <p className="card-description">{course.description}</p>
                  </div>
                  {/* <button className="card-button">Learn More</button> */}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      
      <div className="carousel-dots">
        {courses.map((_, index) => (
          <button
            key={index}
            className={`carousel-dot ${index === activeIndex ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
      
      <div className="note-section">
        <p className="note-text"> 
          <strong className="note-heading">Note:</strong> We are enrolling a limited number of highly dedicated students who are passionate about cutting-edge technology and seeking job-ready courses. Our programs, developed by IITians in collaboration with Industry Projects, offer exceptional opportunities, including paid internships, hands-on experience with real-world applications, and career-driven learning. Students will work on AI/ML agents, LLM missions, advanced learning algorithms, quantum computing, neural network modeling at the quantum level, intelligence systems, and energy sector innovations. 
          Additionally, we provide training in decentralized blockchain application development and other future-tech domains. If you are eager to gain in-depth expertise and build a strong career, we welcome you to be part of our exclusive cohorts.
        </p>
        <a className="enroll-button text-light" href="/enroll">Enroll Now</a>
      </div>
    </div>
  );
};

export default CourseCarousel;